import { Button, Modal, Popconfirm, message } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import Allocate from './Allocate';
import {
  CustomerPoolEnum,
  ReAllocateCustomerParams,
  ReAllocateCustomerV2Params,
  customerController,
} from '../api';
import { useRequest } from 'ahooks';
import { useCompany } from '../hooks/company';

interface Props {
  targets: { name: string; id: I.ID; userId: I.ID }[];
  onSuccess: () => void;
  pool: CustomerPoolEnum;
}

export default ({ targets, onSuccess, pool }: Props) => {
  const { id: companyId } = useCompany();
  const [open, setOpen] = useState<boolean>();
  const [allocation, setAllocation] = useState<ReAllocateCustomerV2Params[]>();
  const [remark, setRemark] = useState<string>();

  useEffect(() => {
    if (open) {
      setRemark(undefined);
      setAllocation(undefined);
    }
  }, [open]);

  const { loading, run } = useRequest(
    () => {
      if (allocation?.length) {
        return customerController.reAllocateV2(companyId, allocation, pool);
      }
      return Promise.reject();
    },
    {
      manual: true,
      onSuccess: () => {
        message.success('重新分派成功');
        onSuccess();
        setOpen(false);
      },
      onError: (e) => {
        message.error(e.message || '重新分派失败');
      },
    },
  );

  const poolName = useMemo(() => {
    switch (pool) {
      case CustomerPoolEnum.BIZ:
        return '业务池';
      case CustomerPoolEnum.PUBLIC:
        return '公共池';
      case CustomerPoolEnum.IDLE:
        return '仓库';
    }
  }, [pool]);

  return (
    <>
      <Modal
        title={`重新分派${poolName}`}
        confirmLoading={loading}
        open={open}
        destroyOnClose
        closeIcon={false}
        footer={[
          <Button key="cancel" loading={loading} onClick={() => setOpen(false)}>
            取消
          </Button>,
          <Popconfirm
            key="ok"
            title={`确认分配${poolName}`}
            onConfirm={() => {
              run();
            }}
          >
            <Button
              type="primary"
              disabled={!targets?.length}
              loading={loading}
            >
              确定
            </Button>
          </Popconfirm>,
        ]}
      >
        <Allocate
          targets={targets}
          remark={remark}
          onRemarkChange={(v) => {
            setRemark(v);
          }}
          onChange={(v) => {
            setAllocation(
              v.map((item) => ({
                userId: item.userId,
                pickCustomerDTOS: item.targets,
              })),
            );
          }}
        />
      </Modal>
      <Button
        type="primary"
        disabled={!targets?.length}
        onClick={() => setOpen(true)}
      >
        重新分派
      </Button>
    </>
  );
};
